import request from '../http';

export const listRoles = (params, config) =>
  request({ url: '/system/roles', method: 'get', params, ...config });

export const createRole = (data) =>
  request({ url: '/system/roles', method: 'post', data });

export const updateRole = (id, data) =>
  request({ url: `/system/roles/${id}`, method: 'put', data });

export const deleteRole = (id) =>
  request({ url: `/system/roles/${id}`, method: 'delete' });

export const getRole = (id) =>
  request({ url: `/system/roles/${id}`, method: 'get' });

/** 仅更新数据权限范围（dataScope + 自定义部门），与若依「分配数据权限」对齐 */
export const updateRoleDataScope = (id, data) =>
  request({ url: `/system/roles/${id}/data-scope`, method: 'put', data });

// 权限已集成到菜单中，通过 menus 接口分配菜单即可同时分配权限
// 后端 IdListRequest 支持 ids 或 menuIds，此处统一传 ids，并确保为数组
export const assignRoleMenus = (roleId, menuIds) => {
  const id = Array.isArray(roleId) ? roleId[0] : roleId;
  const ids = Array.isArray(menuIds) ? menuIds : [];
  return request({ url: `/system/roles/${id}/menus`, method: 'post', data: { ids } });
};

export const assignRoleDepts = (id, deptIds) =>
  request({ url: `/system/roles/${id}/depts`, method: 'post', data: { ids: deptIds } });

export const getRoleMenuIds = (roleId) => {
  const id = Array.isArray(roleId) ? roleId[0] : roleId;
  return request({ url: `/system/roles/${id}/menus`, method: 'get' });
};

export const getRoleDeptIds = (id) =>
  request({ url: `/system/roles/${id}/depts`, method: 'get' });
